<template>
    <div class="pq4-footer">
        <div class="pq4-footer-row1">
            <!--<div class="pq4-footer-data-privacy">
                <a class="pq4-menu-link" :href="dataPrivacyUrl" target="_blank">Data Privacy</a>
            </div>-->
            <div class="pq4-footer-data-privacy">
                <a class="pq4-menu-link" :href="imprintUrl" target="_blank">Imprint</a>
            </div>
            <div class="pq4-footer-legal-notice">
                <a class="pq4-menu-link" :href="legalNoticeUrl" target="_blank">Legal Notice</a>
            </div>
            <!--<div class="pq4-footer-terms">
                <a class="pq4-menu-link" :href="termsUrl" target="_blank">Terms</a>
            </div>-->
        </div>
        <div class="pq4-footer-row2">
            <div class="pq4-copyright">
                <span> © 2024 </span>
                <a href="http://www.schaltzeit.com/" class="pqf-link" target="_blank">Schaltzeit GmbH</a>
                <span> &amp; </span>
                <a href="http://www.cislogic.com/" class="pqf-link" target="_blank">cisLogic GmbH</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterSmall",
        components: {

        },
        data() {
            return {

            };
        },

        created() {
        },
        computed: {
            isSubfolder() {
                return document.URL.toLowerCase().indexOf("/public/") > 0 || document.URL.toLowerCase().indexOf("/views/") > 0
            },
            folder() {
                return this.isSubfolder ? "../Public/" : "./Public/"
            },
            dataPrivacyUrl() {
                return this.folder + "PrivacyPolicy.aspx"
            },
            imprintUrl() {
                return this.folder + "Imprint.aspx"
            },
            termsUrl() {
                return this.folder + "Terms.aspx"
            },
            legalNoticeUrl() {
                return this.folder + "LegalNotice.aspx"
            },
        },
        props: {
            path: {
                type: [String]
            },
        },
        watch: {
        },
        methods: {
        }
    };
</script>



<style scoped>
    .pq4-menu-link {
        color: #304897;
        text-decoration: none;
        font-size: 12px;
    }

        .pq4-menu-link:hover {
            color: #E3CF2B;
        }

    .pq4-footer-row1 {
        display: grid;
        text-align-last: center;
        grid-template-columns: auto auto auto;
        align-self: stretch;
        width: 100%;
        justify-content: center;
        gap: 20px;
    }

    .pq4-footer-row2 {
        font-size: 11px;
        color: gray;
    }

    .pq4-footer {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        gap: 7px;
        align-items: center;
    }
</style>